import { camelCase } from 'change-case'

export default {
  set ({ state, commit }) {
    Object.keys(state.model).forEach((key) => {
      const keyChanged = camelCase(key)
      commit('setAttr', {
        name: keyChanged,
        value: state.model[key]
      })
    })
  }
}
